import React from "react";
import ProfileAndSettings from "views/Config/Profiles/Common";
import SubscriberIdProfilesHelpModal from "./Help";
import SubscriberIdProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import subscriberIdComposition from "./composition";

const ConfigSubscriberIdProfiles = ({ ...settings }) => (
  <>
    <ProfileAndSettings
      {...subscriberIdComposition}
      {...composedAPI}
      {...settings}
    />
    <SubscriberIdProfilesHelpModal />
    <SubscriberIdProfileSettingsHelpModal />
  </>
);

export default ConfigSubscriberIdProfiles;
